export const PATH_CASE_STUDY = '/case-study/:slug/'
export const PATH_CAPABILITY = '/capability/:slug/'
export const COLOR_BRAND = '#da6666'
export const FORMSPREE_CAREERS = 'https://formspree.io/xgzgalem'
export const FORMSPREE_CONTACT = 'https://formspree.io/xvqekbkm'
